import * as React from 'react';
import { Customer } from '../../interfaces';
import useGetCustomerPayments from '../../hooks/customers/useGetCustomerPayments';
import TransactionsList from '../transactions/TransactionsList';
import { convertPaymentsToTransactions } from '../../helpers/payments';

type Props = {
  customer: Customer;
};

export default function CustomerTransactionsSection({ customer }: Props) {
  const { payments, isFetching } = useGetCustomerPayments(customer?.customerId);

  const transactions = React.useMemo(
    () => convertPaymentsToTransactions(payments, { customer }),
    [customer, payments],
  );

  return (
    <TransactionsList transactions={transactions} isLoading={isFetching} />
  );
}
